import React, { useEffect, useState } from 'react';
import { ColumnViewContextProvider } from './context';
import { Tree } from './Tree';

export default function ColumnView({ nodes, selections, selectedNode, getNodeChildren, getRootNode, onCheck }: ColumnViewProps) {
  const [selectionSet, setSelectionSet] = useState<Selections>(new Set());

  useEffect(() => {
    setSelectionSet(new Set(selections));
  
    return () => {
      setSelectionSet(new Set());
    }
  }, [ selections ]);
  
  return (
    <ColumnViewContextProvider>
      <Tree 
        nodes={nodes} 
        selections={selectionSet} 
        getNodeChildren={getNodeChildren} 
        getRootNode={getRootNode} 
        onCheck={onCheck} 
        selectedNode={selectedNode}
      />
    </ColumnViewContextProvider>
  )
}